<cds-header brand="" [name]="authStatus !== 'authenticated' ? '' : workspace">
	<cds-header-navigation *ngIf="authStatus == 'authenticated'">
		<cds-header-item (click)="navigateToPage('funds')" [isCurrentPage]="page == 'funds' || page == 'fund-data'">Funds</cds-header-item>
		<cds-header-item (click)="navigateToPage('files')" [isCurrentPage]="page == 'files' || page == 'file-data'">Files</cds-header-item>
		<cds-header-item (click)="navigateToPage('create-fund')" [isCurrentPage]="page == 'create-fund'">Create Fund</cds-header-item>
		<cds-header-item (click)="navigateToPage('upload-files')" [isCurrentPage]="page == 'upload-files'">Upload Files</cds-header-item>
		<cds-header-item (click)="navigateToPage('compile-data')" [isCurrentPage]="page == 'compile-data'">Compile Data</cds-header-item>
	</cds-header-navigation>

	<cds-header-global *ngIf="authStatus == 'authenticated'">
		<cds-header-action [active]="rightSideOpen" (selected)="onClickAvatar()">
			<svg cdsIcon="user--avatar" size="20"></svg>
		</cds-header-action>
	</cds-header-global>
</cds-header>

<div #panel>
	<cds-panel [expanded]="authStatus == 'authenticated' && rightSideOpen">
		<div style="margin-top: 8px">
			<cds-switcher-list>
				<cds-switcher-list-item (click)="updateTheme()">{{this.theme === 'white' ? 'Dark Mode' : 'Light Mode'}}</cds-switcher-list-item>
				<cds-switcher-list-item (click)="logout()">Sign Out</cds-switcher-list-item>
			</cds-switcher-list>
		</div>
	</cds-panel>
</div>

<cds-loading @fadeIn *ngIf="showSpinner"
	[isActive]="showSpinner"
	[size]="'normal'"
	[overlay]="true"
></cds-loading>

<router-outlet @fadeInUp></router-outlet>

<edit-deal-modal></edit-deal-modal>
<delete-deal-modal></delete-deal-modal>
<delete-file-modal></delete-file-modal>

<!--<notification-->
<!--	@fadeIn-->
<!--	notificationType='success'-->
<!--	[showNotification]="showSuccessNotification"-->
<!--	notificationTitle='File Analysis Complete.'-->
<!--	notificationSubtitle="The extracted data is now ready for your review."-->
<!--&gt;</notification>-->

<!--	notificationSubtitle='The extracted data is now ready for your review.'-->

<!--<notification-->
<!--	@fadeIn-->
<!--	notificationType='warning'-->
<!--	[showNotification]="showAnalyzingNotification"-->
<!--	notificationTitle='File Analysis in Progress.'-->
<!--	notificationSubtitle='This will take some time. Please check back in about 15 minutes.'-->
<!--&gt;</notification>-->

<notification
	@fadeIn
	notificationType='error'
	[showNotification]="showErrorNotification"
	notificationTitle='An error occurred.'
	notificationSubtitle='Please try again, or reach out for assistance.'
></notification>

<notification
	@fadeIn
	notificationType='info'
	[showNotification]="showValueNotFoundNotification"
	notificationTitle='Information Available'
	notificationSubtitle='Kindly review this page for the relevant details.'
></notification>

<notification
	@fadeIn
	[notificationType]=notificationType
	[showNotification]=showNotification
	[notificationTitle]=notificationTitle
	[notificationSubtitle]=notificationSubtitle
></notification>
